import React from "react";
import { Checkbox, Col, Row } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import { CheckboxEventProps, OptionItem } from "../../../../../../Service";

interface Props extends CheckboxEventProps {
    options: OptionItem[];
}
const Index = ({ onChange, value, options, onSave, ...restProps }: Props) => {
    function Change(e: CheckboxValueType[]) {
        onChange?.(e);
        onSave(JSON.stringify(e));
    }
    return (
        <Checkbox.Group
            {...restProps}
            style={{ width: "100%" }}
            value={value}
            onChange={Change}>
            <Row>
                {options.map((item: OptionItem) => (
                    <Col span={4} key={item.id}>
                        <Checkbox value={item.id}>{item.description}</Checkbox>
                    </Col>
                ))}
            </Row>
        </Checkbox.Group>
    );
};

export default Index;
